import { createFileRoute, redirect } from "@tanstack/react-router";

// Redirect map (#592, PARITY.md §5), retargeted by #641: API-key management
// moved off Sending onto MCP & API config, so this legacy flat path now
// points straight there instead of bouncing through `sending/api-keys`
// (itself a redirect since #641 — see that file).
export const Route = createFileRoute("/dashboard/w/$workspaceId/api-keys")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/dashboard/w/$workspaceId/developer/access",
      params: { workspaceId: params.workspaceId },
    });
  },
});
